@if (!group) {
<div [ngClass]="['cd-input', disable ? 'disabled' : '']">
  <label class="cds-body2">
    {{ label }}
    <input
      [ngClass]="[disable ? 'disabled' : '', isHasErrors ? 'ng-invalid ng-touched' : '']"
      [ngModel]="value"
      (ngModelChange)="change($event)"
      #theInput
      (blur)="onBlur()"
      [readOnly]="disable"
      [attr.aria-disabled]="disable"
      [attr.tabindex]="disable ? -1 : null"
      [maxlength]="maxlength"
      placeholder="{{ placeholder }}"
      ngDefaultControl />
  </label>
  <div [ngClass]="['line', isFocus ? 'focus-line' : '', isHasErrors ? 'ng-invalid ng-touched' : '']"></div>
  @if (errorInfo.length > 0) {
  <cds-assistive-text class="error-info" type="error">
    <div class="cds-body2">
      {{ errorInfo }}
    </div>
  </cds-assistive-text>
  } @if (!asyncValidatorLoading && asyncErrorInfo.length > 0) {
  <cds-assistive-text class="error-info" type="error">
    <div class="cds-body2">
      {{ asyncErrorInfo | lang }}
    </div>
  </cds-assistive-text>
  } @if (asyncValidatorLoading) {
  <cds-progress mode="indeterminate"></cds-progress>
  }
</div>
} @if (group) {
<div [formGroup]="group" [ngClass]="['cd-input', disable ? 'disabled' : '']">
  <label class="cds-body2">
    {{ label }}
    <input
      [formControlName]="controlName"
      [ngClass]="[disable ? 'disabled' : '', (group.get(controlName)?.touched && group.get(controlName)?.errors) || isHasErrors ? 'ng-invalid ng-touched' : '']"
      (ngModelChange)="change($event)"
      #theInput
      (blur)="onBlur()"
      [readOnly]="disable"
      [attr.aria-disabled]="disable"
      [attr.tabindex]="disable ? -1 : null"
      [maxlength]="maxlength"
      placeholder="{{ placeholder }}"
      ngDefaultControl />
  </label>
  <div
    [ngClass]="[
      'line',
      isFocus ? 'focus-line' : '',
      (group.get(controlName)?.touched && group.get(controlName)?.errors) || isHasErrors ? 'ng-invalid ng-touched' : ''
    ]"></div>
</div>
}
